import React from "react";

import ConditionSection from "../components/Condition";
import { Link } from "react-router-dom";

const CommercialPage = () => {


    const conditionData = {
    image: "./images/commercial_inspections.jpg", // Replace with actual image path
    heading: "Commercial Inspections: Property Condition Assessment",
    intro: "Inspection of your commercial places is essential as the place where you work or provide your services has a major emphasis on the first impression on your clients.",
    overview: "Our reports provide recommendations, preliminary cost estimates, and priorities for correcting major deficiencies, updating major components at the end of their life, and undertaking further detailed investigations. We use ASTM 2018-15 standards to inspect commercial properties. Our reports consider a five-year time frame for major repairs or replacements of building components, as most financial institutions require.",
    introNote: "Following are some of the types of commercial places where we carry out our inspection:",
    types: [
        {
            title: "Industrial Buildings–",
            text: "We conduct a detailed visual and structural review of industrial buildings. This covers electrical, roofing, plumbing, flashing, chimneys, fire & safety and mechanical systems. Buildings covered under such inspections include industrial complexes, warehouses, retail stores, industrial manufacturing plants, and commercial establishments."
        },
        {
            title: "Office Buildings–",
            text: "Commercial condos, retail blocks, restaurants, medical centers, plazas, certain industrial units, and shopping centers are all covered under office buildings. They are checked for safety standards and work standards."
        },
        {
            title: "",
            text: "Inspection of commercial places is vital because it is associated with the lives and health of a number of people. We, at Technominds have been inspecting commercial places for years. We excel in commercial property inspections and generally, it covers;"
        }
    ],
    checklist: [
        "Structural Frame (Building Exterior & Envelope)",
        "Roof Surfaces",
        "Windows & Doors",
        "Plumbing System and Components",
        "Electrical System, Outlets, & Components",
        "Installed Mechanical Systems",
        "Installed Interior Elements",
        "HVAC Systems (Heating, Cooling, Ventilation Systems)",
        "Document Review (if supplied)",
        "Probable Cost & Recommendations (if requested)"
    ],
    summary: "When we complete our inspection, we send you a detailed inspection report with pictures, to better understand. Our reports are designed for quick decision-making, with an easy-to-follow summary of recommendations, costs, and priorities.",
    standards: "Our commercial reports are conducted following the American Society for Testing and Materials (ASTM) Standard Guide for Property Condition Assessments, Baseline Property Condition Assessment Process E 2018-15, and generally accepted industry standards.",
    contactNote: "Call us today to get your commercial property condition assessment, at 416 500 1535."
};
  

  return (
    <>
      <div class="common-001">
        <section className="section-banner">
          <div className="container">
            <div className="inner-content">
              <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
              <h1>
                Commercial Inspections:<span> Property Condition Assessment</span>
              </h1>
              <p>
                Discover peace of mind with our expert home inspection services,
                designed to meet the needs of both real estate agents and
                property owners. Our team ensures thorough evaluations and
                prompt reporting, helping you make informed decisions.
              </p>
              <div className="dft-btn">
                <Link to="/industerial-building" className="btn">
                  For Inspection Services
                </Link>
              </div>
            </div>
          </div>
        </section>


<ConditionSection conditionData={conditionData} />
        
      </div>
    </>
  );
};

export default CommercialPage;
